import { Floor } from "shared/types/Floor"
import { ProductPosition } from "shared/types/ProductPosition"
import {
  FloorTypename,
  ProductPositionTypename,
  ProjectChild,
  ProjectTypename,
  RoomTypename
} from "shared/types/Project"
import { Room } from "shared/types/Room"
import { ProjectParent } from "shared/types/__generated__/graphql"

import { RestLink } from "apollo-link-rest"

type PatchableProjectChild = ProjectChild & { type: string }
type PatchableProjectParent = ProjectParent & { type: string }

export function patchProjectChildrenType(
  projectChild: PatchableProjectChild,
  outerType: string,
  patchDeeper: RestLink.FunctionalTypePatcher,
  context: RestLink.TypePatcherContext
): ProjectChild {
  if (projectChild.type === RoomTypename) {
    return patchDeeper(
      {
        ...(projectChild as Room),
        __typename: RoomTypename
      },
      outerType,
      patchDeeper,
      context
    )
  }

  if (projectChild.type === FloorTypename) {
    return patchDeeper(
      {
        ...(projectChild as Floor),
        __typename: FloorTypename
      },
      outerType,
      patchDeeper,
      context
    )
  }

  return patchDeeper(
    {
      ...(projectChild as ProductPosition),
      __typename: ProductPositionTypename
    },
    outerType,
    patchDeeper,
    context
  )
}

export function patchProjectParentType(
  parent: PatchableProjectParent,
  outerType: string,
  patchDeeper: RestLink.FunctionalTypePatcher,
  context: RestLink.TypePatcherContext
): ProjectParent {
  const children = parent.children
    ? parent.children.map(child =>
        patchProjectChildrenType(
          child as PatchableProjectChild,
          outerType,
          patchDeeper,
          context
        )
      )
    : parent.children

  return {
    ...parent,
    children,
    __typename: parent.type as
      | typeof ProjectTypename
      | typeof RoomTypename
      | typeof FloorTypename
  } as ProjectParent
}
